import { ThemeConfig } from 'antd';
import { FC, ReactNode, createContext, useContext } from 'react';

type Props = { theme: ThemeConfig; children: ReactNode };
const defaultTheme: ThemeConfig = {
    token: {
        colorPrimary: '#44338a',
        fontFamily: 'Open Sans',
        colorPrimaryBg: '#F7F5FF',
    },
};
export const ThemeContext = createContext(defaultTheme);

const ThemeProvider: FC<Props> = ({ theme, children }) => (
    <ThemeContext.Provider value={theme || defaultTheme}>{children}</ThemeContext.Provider>
);

export const useTheme = () => useContext(ThemeContext);

export default ThemeProvider;
